import {OrderLine} from "./orderline";
import {Address} from "./address";
import {Customer} from "./customer";

export enum OrderStatus {
  ERROR_PROCESSING_ORDER = 10000,
  PENDING_TO_PAY = 1,
  PENDING_TO_PROCESS = 2,
  PARTIALLY_SENT_TO_EXCHANGERS = 3,
  FULLY_SENT_TO_EXCHANGERS = 4,
  PARTIALLY_PROCESSED = 5,
  FULLY_PROCESSED = 6,
  PARTIALLY_DELIVERED = 9,
  FULLY_DELIVERED = 10,
  PARTIALLY_REFUNDED = 11,
  FULLY_REFUNDED = 12,
  PARTIALLY_CANCELLED = 13,
  FULLY_CANCELLED = 14,
  WAITING_PAYMENT_VIA_BANK_TRANSFER = 21,
  ABANDONED = 101
}

export class Order {


  public id: string;
  public customer: Customer;
  public status: number;
  public secretKey: string;
  public invoiceNumber: number;
  public gclid: string;
  public referral: string;
  public currencyIsoCode: string;
  public paymentData: any;
  public analyticsClientId: string;
  public couponCode: string;
  public discount: number = 0;
  public couponError: boolean = false;
  public shippingMethod: string;
  public orderNumber: string;
  public orderLines: Array<OrderLine> = new Array();
  public billingAddress: Address = new Address();

}

